import { useEffect, useRef, useState } from "react";
import { useServerApi } from "./userServerApi";
import { mergeExtraFieldsIntoSchema } from "../helpers/mergeExtraFieldsIntoSchema";
import { fetchExtraFieldSetting } from "../helpers/extraFieldSetting";

export const fetchHasExtraFieldsForEdit = async (api, entityType) => {
  const result = await api.search({
    apiEntity: "extraField",
    pageSize: 1,
    currentPage: 1,
    searchQuery: {
      entityType,
      active: true,
      showInEditForm: true,
    },
    byAggregation: false,
  });
  return (result?.total ?? result?.docs?.length ?? 0) > 0;
};

export const useExtraFieldsFormSchema = (
  baseSchema,
  entityType,
  mergeOptions = {},
  deps = []
) => {
  const [api] = useServerApi();
  const apiRef = useRef(api);
  apiRef.current = api;
  const [schema, setSchema] = useState(baseSchema);

  useEffect(() => {
    let mounted = true;
    setSchema(baseSchema);

    (async () => {
      try {
        const [hasFields, displaySetting] = await Promise.all([
          fetchHasExtraFieldsForEdit(apiRef.current, entityType),
          fetchExtraFieldSetting(apiRef.current, entityType),
        ]);
        if (!mounted) return;
        setSchema(
          hasFields
            ? mergeExtraFieldsIntoSchema(baseSchema, entityType, {
                ...mergeOptions,
                placement: displaySetting.placement,
                columns: displaySetting.columns,
              })
            : baseSchema
        );
      } catch (error) {
        if (mounted) setSchema(baseSchema);
      }
    })();

    return () => {
      mounted = false;
    };
    // baseSchema is intentionally read from closure when deps change
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entityType, ...deps]);

  return schema;
};
